import * as tslib_1 from "tslib";
import { AfterViewInit, ViewContainerRef } from '@angular/core';
import { Api } from '../../../api/api';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var LayerFilterSelectorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerFilterSelectorComponent, _super);
    function LayerFilterSelectorComponent(_vcr, api, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.api = api;
        _this.layerService = layerService;
        _this.filtersAndIds = [];
        _this.addQueryToList = function (layerId, query) {
            _this.filtersAndIds.find(function (x) { return x.id === layerId; }).query = query;
        };
        return _this;
    }
    Object.defineProperty(LayerFilterSelectorComponent.prototype, "selectedLayers", {
        get: function () {
            return this._selectedLayers;
        },
        set: function (ids) {
            this._selectedLayers = ids;
            this.defineFiltersAndIds();
        },
        enumerable: true,
        configurable: true
    });
    LayerFilterSelectorComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.isReady();
                return [2 /*return*/];
            });
        });
    };
    LayerFilterSelectorComponent.prototype.defineFiltersAndIds = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, layerNames, _loop_1, this_1, _b, _c, id;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getLayerNames()];
                    case 1:
                        layerNames = _d.sent();
                        _loop_1 = function (id) {
                            var name_1 = layerNames.filter(function (x) { return x.id === id; })[0].name;
                            this_1.filtersAndIds.push({ id: id, query: null, name: name_1 });
                        };
                        this_1 = this;
                        try {
                            for (_b = tslib_1.__values(this.selectedLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                id = _c.value;
                                _loop_1(id);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerFilterSelectorComponent.prototype.getLayerNames = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n        query {\n            layers(id: [" + this.selectedLayers + "]){\n                id\n                name\n            }\n        }", {}, 'GET', 'layers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerFilterSelectorComponent.prototype.openFilter = function (layerId) {
        var layer = this.filtersAndIds.filter(function (x) { return x.id === layerId; })[0];
        var openBasicFilter = new CustomEvent('openBasicFilter', { detail: { layer: layer }, composed: true });
        window.dispatchEvent(openBasicFilter);
    };
    LayerFilterSelectorComponent.prototype.addLayersToMap = function () {
        var e_2, _a;
        try {
            for (var _b = tslib_1.__values(this.filtersAndIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                var layer = _c.value;
                var layerSettings = { id: layer.id, query: layer.query ? layer.query : null };
                this.layerService.addMapcoreLayersToMap([layerSettings]);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.selectedLayers = [];
        this.filtersAndIds = [];
        this.getClosestAncestor('mc-window').then(function (window) {
            if (window) {
                window.close();
            }
        });
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Array),
        tslib_1.__metadata("design:paramtypes", [Array])
    ], LayerFilterSelectorComponent.prototype, "selectedLayers", null);
    return LayerFilterSelectorComponent;
}(BaseComponent));
export { LayerFilterSelectorComponent };
